import api from '@/api'

const state = {
  stats: {},
  recentActivity: [],
  systemStatus: {},
  realTimeData: {},
  loading: false,
  error: null
}

const mutations = {
  SET_STATS(state, stats) {
    state.stats = stats
  },
  SET_RECENT_ACTIVITY(state, activity) {
    state.recentActivity = activity
  },
  SET_SYSTEM_STATUS(state, status) {
    state.systemStatus = status
  },
  SET_REAL_TIME_DATA(state, data) {
    state.realTimeData = { ...state.realTimeData, ...data }
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  CLEAR_ERROR(state) {
    state.error = null
  }
}

const actions = {
  async fetchStats({ commit }) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      const response = await api.get('/dashboard/stats')
      commit('SET_STATS', response.data)
      
      return response.data
    } catch (error) {
      commit('SET_ERROR', 'Error al cargar estadísticas')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchRecentActivity({ commit }) {
    try {
      const response = await api.get('/dashboard/activity')
      commit('SET_RECENT_ACTIVITY', response.data)
      
      return response.data
    } catch (error) {
      commit('SET_ERROR', 'Error al cargar actividad reciente')
      throw error
    }
  },

  async fetchSystemStatus({ commit }) {
    try {
      const response = await api.get('/dashboard/status')
      commit('SET_SYSTEM_STATUS', response.data)
      
      return response.data
    } catch (error) {
      commit('SET_ERROR', 'Error al cargar estado del sistema')
      throw error
    }
  },

  async fetchRealTimeData({ commit }) {
    try {
      const response = await api.get('/dashboard/realtime')
      commit('SET_REAL_TIME_DATA', response.data)
      
      return response.data
    } catch (error) {
      commit('SET_ERROR', 'Error al cargar datos en tiempo real')
      throw error
    }
  },

  async initialize({ dispatch }) {
    try {
      await Promise.all([
        dispatch('fetchStats'),
        dispatch('fetchRecentActivity'),
        dispatch('fetchSystemStatus'),
        dispatch('fetchRealTimeData')
      ])
    } catch (error) {
      // Error initializing dashboard module - handled silently
    }
  }
}

const getters = {
  stats: state => state.stats,
  recentActivity: state => state.recentActivity,
  systemStatus: state => state.systemStatus,
  realTimeData: state => state.realTimeData,
  loading: state => state.loading,
  error: state => state.error,
  
  // Computed stats
  totalSensors: state => state.stats.totalSensors || 0,
  activeSensors: state => state.stats.activeSensors || 0,
  totalDevices: state => state.stats.totalDevices || 0,
  onlineDevices: state => state.stats.onlineDevices || 0,
  activeAlerts: state => state.stats.activeAlerts || 0,
  systemUptime: state => state.stats.systemUptime || 0,
  
  // System health
  systemHealth: state => {
    const status = state.systemStatus
    if (!status) return 'unknown'
    
    if (status.overall === 'healthy') return 'healthy'
    if (status.overall === 'warning') return 'warning'
    if (status.overall === 'critical') return 'critical'
    return 'unknown'
  },
  
  // Recent activity by type
  recentAlerts: state => {
    return state.recentActivity.filter(activity => activity.type === 'alert')
  },
  
  recentReadings: state => {
    return state.recentActivity.filter(activity => activity.type === 'reading')
  },
  
  recentSystemEvents: state => {
    return state.recentActivity.filter(activity => activity.type === 'system')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 


// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js